export default "__VITE_ASSET__Ll2uyJsv__"